/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Approval_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Approve or disapprove event" |
*
* @param {Event_Approval_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_approval_aria_label = /** @type {((inputs?: Event_Approval_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Approval_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuver ou desapprouver l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis genehmigen oder ablehnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approva o disapprova l'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрить или отклонить мероприятие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobar o desaprobar el evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批准或不批准活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを承認または不承認にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम को स्वीकृत या अस्वीकृत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovar ou reprovar o evento")
	return /** @type {LocalizedString} */ ("Approve or disapprove event")
});